import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { IconArrowLeft, IconSelected, Popup } from '@ui/src';
import { useAppDispatch } from '@store';
import { clearNewApplicationInfoState } from '../store/slices';
import { ApplicationWrapperTypes } from './types';

import ROUTES from '../../../../routes';

import cn from '../../common/styles.module.css';

const ApplicationWrapper = ({
  isDirty,
  questionnarieIsDirty,
  setDirtyPopupVisible,
  children,
  dirtyPopupVisible,
  successMessageVisible,
  link,
  linkRef,
}: ApplicationWrapperTypes) => {
  const navigate = useNavigate();

  const { search } = useLocation();
  const dispatch = useAppDispatch();

  return (
    <div className={cn.newApplicationInfo}>
      <div className={cn.newApplicationLinkWrapper}>
        <button
          type="button"
          className={cn.newApplicationBackLink}
          onClick={() => {
            if (isDirty || questionnarieIsDirty) {
              setDirtyPopupVisible(true);
            } else {
              navigate(
                `${ROUTES.CUSTOMERS_NEW_APPLICATION_LIST}${search || ''}`,
              );
              dispatch(clearNewApplicationInfoState());
            }
          }}
        >
          <IconArrowLeft width={13} height={11} />
          Back
        </button>
      </div>
      {children}
      <Outlet />
      <Popup
        title="You have unsaved changes that will be lost"
        description="Are you sure you want to close this form?"
        onCancelClick={() => setDirtyPopupVisible(false)}
        onOkClick={() =>
          navigate(`${ROUTES.CUSTOMERS_NEW_APPLICATION_LIST}${search || ''}`)
        }
        cancelButtonText="Cancel"
        okButtonText="Close"
        isVisible={dirtyPopupVisible}
      />
      {successMessageVisible && (
        <div className={cn.successAppliedMessage}>
          <IconSelected />
          <div>Risk Score successfully updated to the Customer Application</div>
        </div>
      )}
      <a href={link} ref={linkRef} aria-label="error link" target="_self" />
      <div id="signature-popup" />
    </div>
  );
};

export default ApplicationWrapper;
